import React from 'react';
import {useForm} from 'react-final-form';

export function getDeadlineDate(urgency, urgencyOptions) {
    if (!urgencyOptions) return null;
    const opt = urgencyOptions[urgency];
    if (!opt || !opt.hours) return null;
    return new Date(Date.now() + opt.hours * 3600000);
}

export function formatDeadlineShort(date) {
    if (!date) return '';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${dd}.${mm}.${date.getFullYear()}`;
}

function formatDeadlineFull(date) {
    if (!date) return '';
    const short = formatDeadlineShort(date);
    const hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const h12 = hours % 12 || 12;
    const offset = -date.getTimezoneOffset() / 60;
    const gmt = (offset >= 0 ? '+' : '') + String(Math.floor(offset)).padStart(2, '0');
    return `${short} ${h12} ${ampm} (GMT${gmt})`;
}

export default function Urgency({urgency: urgencyOptions}) {
    const form = useForm();
    const value = form.getState().values.urgency;

    const select = (key) => {
        form.change('urgency', key);
    };

    if (!urgencyOptions) return null;

    const deadline = getDeadlineDate(value, urgencyOptions);

    return <div className="resume-form__urgency">
        <div className="resume-form__tab-selector">
            {Object.entries(urgencyOptions).map(([key, ur]) => (
                <div key={key}
                     className={`tab-select ${value === key ? 'active' : ''}`}
                     onClick={() => select(key)}>
                    <a><strong>{ur.name}</strong></a>
                </div>
            ))}
        </div>
        <div className="annotation">
            The Deadline for your order is <span className="deadline-data">{formatDeadlineFull(deadline)}</span>
        </div>
    </div>;
}
